// extracted by mini-css-extract-plugin
export default {"formContainer":"formContainer__ODFjZ","inputsWrapper":"inputsWrapper__N2RmN","verticalStack":"verticalStack__ODE5N","ctaWrapper":"ctaWrapper__ZmQxN"};